import React from 'react';

import { ActionButton, LinkButton } from '@eika/button';
import { InfoCard } from '@eika/card';
import { IconTypes } from '@eika/icon';
import { Link, LinkType } from '@eika/link';
import { RichIcon, RichIconTypes } from '@eika/rich-icon';

import { useConfig } from '../../defaultConfig';
import useStepUp from '../../hooks/useStepUp';
import useTranslation from '../../hooks/useTranslation';

import './RiskyDevice.scss';

const RiskyDeviceMobile = () => {
    const translated = useTranslation();
    const { stepUpAuthLink } = useConfig();
    const { showStepupConfiguration } = useStepUp();

    return (
        <InfoCard className="risky-device-info-card" skipBackground>
            <RichIcon type={RichIconTypes.HAAND_HEIHEI} />
            {showStepupConfiguration ? (
                <div className="risky-device-info-card__text-wrapper">
                    <InfoCard.TitleH3>{translated.updatePaymentLimits.stepUpRequired.title}</InfoCard.TitleH3>
                    <span>{translated.updatePaymentLimits.stepUpRequired.text}</span>
                    <span>{translated.updatePaymentLimits.stepUpRequired.text2}</span>
                    <div className="risky-device-info-card__buttons-wrapper">
                        <Link linkType={LinkType.BUTTON_STANDARD_POSITIVE} href={stepUpAuthLink?.url ?? '/'}>
                            {translated.updatePaymentLimits.stepUpRequired.stepUpButton}
                        </Link>
                        <LinkButton onClick={() => window.history.back()}>{translated.cancel}</LinkButton>
                    </div>
                </div>
            ) : (
                <div className="risky-device-info-card__text-wrapper">
                    <InfoCard.TitleH3>{translated.updatePaymentLimits.mobileRiskyDevice.title}</InfoCard.TitleH3>
                    <span>{translated.updatePaymentLimits.mobileRiskyDevice.text}</span>
                    <span>{translated.updatePaymentLimits.mobileRiskyDevice.text2}</span>
                    <div className="risky-device-info-card__buttons-wrapper">
                        <ActionButton icon={IconTypes.TELEFON_36}>
                            {translated.updatePaymentLimits.mobileRiskyDevice.buttonText}
                        </ActionButton>
                    </div>
                </div>
            )}
        </InfoCard>
    );
};

export default RiskyDeviceMobile;
